function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSendRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.011 5c-.142 0-.286.015-.433.046L3.581 10.188c-1.684.362-2.154 2.542-.766 3.564l1.695 1.25L24.507 7.75 9.234 16l-.003-.003L8 16.662V27l6.364-4.738 4.734 3.489a1.998 1.998 0 003.009-.789L29.82 7.821C30.431 6.464 29.405 5 28.011 5z",
    fill: props.color
  }));
}

export default SvgIconSendRexFilled;